import type { FC } from 'react'

import { classNames } from '@/utils/helpers'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  dotClassName?: string
}

export const ThreeDotsLoader: FC<Props> = ({ className, dotClassName }) => {
  return (
    <div
      className={classNames(
        'ml-2 flex items-center justify-center space-x-0.5',
        className,
      )}
    >
      <span
        className={classNames(
          'h-1 w-1 animate-bounce rounded-full bg-black [animation-delay:-0.3s] dark:bg-white',
          dotClassName,
        )}
      />
      <span
        className={classNames(
          'h-1 w-1 animate-bounce rounded-full bg-black [animation-delay:-0.15s] dark:bg-white',
          dotClassName,
        )}
      />
      <span
        className={classNames(
          'h-1 w-1 animate-bounce rounded-full bg-black dark:bg-white',
          dotClassName,
        )}
      />
    </div>
  )
}
